module.exports = __webpack_public_path__ + "static/media/CTLI_6-444w.a3cafe74.webp";